import { render, staticRenderFns } from "./CardWebsiteStatistics.vue?vue&type=template&id=350940cf&scoped=true&"
import script from "./CardWebsiteStatistics.vue?vue&type=script&lang=js&"
export * from "./CardWebsiteStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CardWebsiteStatistics.vue?vue&type=style&index=0&id=350940cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350940cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VSpacer})
